import IssuesListTable from "./components/IssuesListTable";

export default IssuesListTable